import { useCallback, useState } from 'react';
import { AuthForm } from '~/widgets/AuthForm';
import './AdminLoginPage.css';
import { loginRequest } from '~/features/auth';
import type { Credentials } from '~/shared/types';
import joinUrls from '~/shared/lib/url/joinUrls';
import { UCHI_HOST_URL } from '~/shared/lib/env/envVariables';

export const AdminLoginPage = () => {
  const [error, setError] = useState('');

  const onSubmit = useCallback(async (credentials: Credentials) => {
    setError('');

    const res = await loginRequest({
      ...credentials,
    });

    if (res.success) {
      window.open(joinUrls(UCHI_HOST_URL, res.nextPath || 'home'), '_self');
    } else if (res.error) {
      setError(res.error);
    }
  }, []);

  return (
    <div className="auth-form-container">
      <AuthForm onSubmit={onSubmit} error={error} />
    </div>
  );
};
